module.exports = __webpack_public_path__ + "img/CellTowerOutlined.2fc5b006.svg";